import { SyncOutlined } from "@ant-design/icons";
import React from "react";

export const gridTitleWithReset = (label: string, onReset?: () => void, hideReset?: boolean) => (
  <span
    style={{ display: "inline-flex", alignItems: "center", justifyContent: "space-between", gap: 4, width: "100%" }}
  >
    {label}
    {!hideReset && (
      <SyncOutlined
        style={{ fontSize: 14, cursor: "pointer" }}
        onClick={(e) => {
          e.stopPropagation();
          onReset?.();
        }}
      />
    )}
  </span>
);
